import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { LayoutModule } from '@angular/cdk/layout';
import { RouterModule, Router } from '@angular/router';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSidenavModule } from '@angular/material/sidenav';
import { PortalModule } from '@angular/cdk/portal';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

import { OptionALayoutComponent } from './layouts/option-a/option-a-layout.component';
import { OptionBLayoutComponent } from './layouts/option-b/option-b-layout.component';
import { OptionCLayoutComponent } from './layouts/option-c/option-c-layout.component';
import { OptionDLayoutComponent } from './layouts/option-d/option-d-layout.component';
import { EmptyLayoutComponent } from './layouts/empty/empty-layout.component';

import { TopNavbarComponent } from './top-navbar/top-navbar.component';
import { SideNavbarComponent } from './side-navbar/side-navbar.component';
import { MainMenuComponent } from './side-menus/main-menu/main-menu.component';
import { DynamicMenuComponent } from './side-menus/dynamic-menu/dynamic-menu.component';
import { NotificationsMenuComponent } from './side-menus/notifications-menu/notifications-menu.component';
import { SettingsMenuComponent } from './side-menus/settings-menu/settings-menu.component';
import { SearchMenuComponent } from './side-menus/search-menu/search-menu.component';

import { ColorPalettesService } from './color-palettes/color-palettes.service';
import { CustomIconsService } from './custom-icons/custom-icons.service';
import { MobileLayoutComponent } from './layouts/mobile/mobile-layout.component';
import { DynamicLayoutComponent } from './layouts/dynamic/dynamic-layout.component';
import { AuthenticationModule } from 'src/app/authentication/authentication.module';
import { TeamsLayoutComponent } from './layouts/teams-layout/teams-layout.component';
import { TeamsTopNavbarComponent } from './layouts/teams-top-navbar/teams-top-navbar.component';
import { ClarityMenuComponent } from './side-menus/clarity-menu/clarity-menu.component';
import { ClarityLayoutComponent } from './layouts/clarity-layout/clarity-layout.component';
import { SandStormLayoutComponent } from './layouts/sand-storm-layout/sand-storm-layout.component';
import { BetaLayoutComponent } from './layouts/beta-layout/beta-layout.component';
import { ClarityHistoryComponent } from './side-menus/clarity-history/clarity-history/clarity-history.component';
import { BusinessMenuComponent } from './side-menus/business-menu/business-menu.component';
import { DoubleCoachMenuComponent } from './side-menus/doublecoach-menu/doublecoach-menu.component';
import { BetaMenuComponent } from './side-menus/beta-menu/beta-menu.component';
import { SafeMenuComponent } from './sidemenus/safe-menu/safe-menu.component';
import { SideMenusService } from './side-menus/side-menus.service';
import { TeamsModule } from '../teams/teams.module';

@NgModule({
  declarations: [
    OptionALayoutComponent,
    OptionBLayoutComponent,
    OptionCLayoutComponent,
    OptionDLayoutComponent,
    EmptyLayoutComponent,
    TopNavbarComponent,
    SideNavbarComponent,
    MainMenuComponent,
    DynamicMenuComponent,
    NotificationsMenuComponent,
    SettingsMenuComponent,
    SearchMenuComponent,
    MobileLayoutComponent,
    DynamicLayoutComponent,
    TeamsLayoutComponent,
    TeamsTopNavbarComponent,
    ClarityMenuComponent,
    ClarityLayoutComponent,
    SandStormLayoutComponent,
    BetaLayoutComponent,
    ClarityHistoryComponent,
    BusinessMenuComponent,
    DoubleCoachMenuComponent,
    BetaMenuComponent,
    SafeMenuComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    PortalModule,
    LayoutModule,
    MatSidenavModule,
    MatExpansionModule,
    NgbDropdownModule,
    AuthenticationModule,
    TeamsModule
  ],
  exports: [
    OptionALayoutComponent,
    OptionBLayoutComponent,
    OptionCLayoutComponent,
    OptionDLayoutComponent,
    EmptyLayoutComponent,
    TopNavbarComponent,
    SideNavbarComponent,
    MainMenuComponent,
    DynamicMenuComponent,
    NotificationsMenuComponent,
    SettingsMenuComponent,
    SearchMenuComponent,
    MobileLayoutComponent,
    DynamicLayoutComponent,
    ClarityMenuComponent,
    ClarityLayoutComponent,
    SandStormLayoutComponent,
    BetaLayoutComponent,
    ClarityHistoryComponent,
    BusinessMenuComponent,
    DoubleCoachMenuComponent,
    BetaMenuComponent
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (colorPalettesService: ColorPalettesService) => {
        return () => colorPalettesService.init();
      },
      deps: [ColorPalettesService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (customIconsService: CustomIconsService) => {
        return () => customIconsService.init();
      },
      deps: [CustomIconsService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (sideMenus: SideMenusService, router: Router) => {
        return () => {
          sideMenus.recomputeSafariBetaShellMainMenu(router.url);
        };
      },
      deps: [SideMenusService, Router],
      multi: true
    }
  ]
})
export class CoreModule { }
